module.exports = __webpack_public_path__ + "media/images/tree-4872eb3c.png";